const time = 600;

export default class ScrollToElement {
    constructor(element) {
        this.$element  = $(element);
        this.$to       = $(this.$element.attr('data-scroll-to-element') + ':visible').eq(0);
    }

    scroll() {
        if (this.$to.length === 0) {
            return;
        }

        $('html, body').animate({
            scrollTop: this.$to.offset().top
        }, time);
    }

    setListeners() {
        this.$element
            .off('click.scrollToElement')
            .on('click.scrollToElement', this.scroll.bind(this));
    }

    init() {
        this.setListeners();
    }
}
